import { DetectionFilterCategory } from "../../../../utils/constants";

export const DASHBOARD_TOP_CARD_LIMIT = 5;

const WAF_CARD_FILTER_MAP = {
  [DetectionFilterCategory.TopWAFDetectionsByCountry]: { id: "country", label: "Country" },
  [DetectionFilterCategory.TopUserAgent]: { id: "ua", label: "User Agent" },
  [DetectionFilterCategory.TopPath]: { id: "uri", label: "URI Path" },
  [DetectionFilterCategory.TopEventBySource]: { id: "src_ip", label: "IP Address" },
  [DetectionFilterCategory.TopMethod]: { id: "method", label: "Method" },
  [DetectionFilterCategory.TopDetection]: { id: "attack_type", label: "Attack Type" },
};

const BOT_CARD_FILTER_MAP = {
  country: { id: "country", label: "Country" },
  ua: { id: "ua", label: "User Agent" },
  uri: { id: "uri", label: "URI Path" },
  source_ip: { id: "src_ip", label: "IP Address" },
  method: { id: "method", label: "Method" },
  host: { id: "hostname", label: "Hostname" },
  ja3_hash: { id: "ja3_hash", label: "JA3 Fingerprint" },
};

function buildFilterPill(map, category, value) {
  const def = map[category];
  if (!def || value === null || value === undefined) return [];
  const text = String(value).trim();
  if (!text) return [];
  return [{ id: def.id, label: def.label, value: text }];
}

/** Build EventFilterBar pills for WAF Events from a dashboard top-card row. */
export function buildWafEventFiltersFromDashboardCard(category, value) {
  return buildFilterPill(WAF_CARD_FILTER_MAP, category, value);
}

/** Build EventFilterBar pills for Bot Events from a bot dashboard top-card row. */
export function buildBotEventFiltersFromDashboardCard(category, value) {
  return buildFilterPill(BOT_CARD_FILTER_MAP, category, value);
}

/** Apply dashboard time_range object to WAF/Bot event page local state setters. */
export function applyDashboardTimeRangeToEventPage(timeRangePayload, { setTimeRange, setCustomDateRange, setCustomRangeConfirm }) {
  if (!timeRangePayload || typeof timeRangePayload !== "object") return;

  if (timeRangePayload.period) {
    setTimeRange(timeRangePayload.period);
    setCustomRangeConfirm(false);
    return;
  }

  if (timeRangePayload.from && timeRangePayload.to) {
    setTimeRange("custom");
    setCustomDateRange([timeRangePayload.from, timeRangePayload.to]);
    setCustomRangeConfirm(true);
  }
}

/**
 * Read navigation state from a dashboard top-card click (sync, before first fetch).
 * Also accepts flat state from Smart Parse drawer (`timeRange` string + `customDateRange`).
 * @returns {{ initialFilters: object[], timeRange?: string, customDateRange?: string[], customRangeConfirm?: boolean } | null}
 */
export function readDashboardEventDeepLinkState(locationState) {
  if (!locationState || typeof locationState !== "object") return null;

  const initialFilters = Array.isArray(locationState.initialFilters) ? locationState.initialFilters : [];
  const timeRangePayload = locationState.timeRange;
  const hasFilters = initialFilters.length > 0;
  const hasNestedTime =
    timeRangePayload &&
    typeof timeRangePayload === "object" &&
    (typeof timeRangePayload.period === "string" ||
      (typeof timeRangePayload.from === "string" && typeof timeRangePayload.to === "string"));
  const hasFlatTime =
    typeof locationState.timeRange === "string" &&
    (locationState.timeRange !== "custom" || Array.isArray(locationState.customDateRange));

  if (!hasFilters && !hasNestedTime && !hasFlatTime) return null;

  const out = { initialFilters };
  if (hasNestedTime) {
    if (timeRangePayload.period) {
      out.timeRange = timeRangePayload.period;
      out.customRangeConfirm = false;
    } else if (timeRangePayload.from && timeRangePayload.to) {
      out.timeRange = "custom";
      out.customDateRange = [timeRangePayload.from, timeRangePayload.to];
      out.customRangeConfirm = true;
    }
  } else if (hasFlatTime) {
    out.timeRange = locationState.timeRange;
    if (Array.isArray(locationState.customDateRange)) {
      out.customDateRange = locationState.customDateRange;
    }
    if (locationState.customRangeConfirm != null) {
      out.customRangeConfirm = locationState.customRangeConfirm;
    }
  }
  return out;
}
